<template>
  <div id="app" v-bind:class="[darkMode ? 'dark-mode' : 'light-mode']">
    <div id="preferencesContainer">
      <img
        class="preference"
        src="./assets/moon.png"
        v-on:click="toggleDarkMode"
        alt="Toggle Dark Mode"
      />
    </div>
    <img src="./assets/longcat.png" />
    <Board v-bind:class="[darkMode ? 'dark-mode' : 'light-mode']"></Board>
  </div>
</template>
<script>
import Board from "./components/Board.vue";
export default {
  name: "App",
  data() {
    return {
      darkMode:
        localStorage.darkMode !== undefined
          ? JSON.parse(localStorage.darkMode)
          : window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches,
    };
  },
  methods: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.darkMode = this.darkMode;
    },
    updateHtmlBackground() {
      document.documentElement.style.backgroundColor = this.darkMode
        ? "rgb(15, 15, 15)"
        : "white";
    },
  },
  watch: {
    darkMode() {
      this.updateHtmlBackground();
    },
  },
  mounted() {
    this.updateHtmlBackground();
  },
  components: {
    Board,
  },
};
</script>

<style>
html, body {
  overscroll-behavior: none;
}
html {
  z-index: -1;
}
body {
  margin: 0px;
}
.light-mode {
  --post-box-text-color: black;
  --text-color: black;
  --background-color: white;
  background-color: var(--background-color);
  transition: all ease-in-out 0.75s;
}
.dark-mode {
  --post-box-text-color: rgb(201, 201, 201);
  --text-color: rgb(199, 199, 199);
  --background-color: rgb(15, 15, 15);
  background-color: var(--background-color);
  transition: all ease-in-out 0.75s;
}
#preferencesContainer {
  padding: 10px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
}
.preference {
  width: 30px;
  height: 30px;
}
#board {
  position: relative;
  z-index: 10;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 5%;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>
